import {useMutation, useQueryClient} from 'react-query';
import {IBankAccountInfo} from '../getBankAccountInfo/getBankAccountInfo';
import {patchBankAccountInfo} from './patchBankAccountInfo';
import {toast} from 'react-toastify';
import {extractApiErrors} from '../../../../../global/helpers/extractApiErrors';
import {convertErrorsToPersian} from '../postBankAccountInfo/bankAccountErrorMapper';

const usePatchBankAccountInfo = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: IBankAccountInfo) => patchBankAccountInfo(payload),

    onSuccess: () => {
      queryClient.invalidateQueries(['get-bank-account-info']);
    },

    onError: error => {
      const errors = extractApiErrors(error);
      const persianErrors = convertErrorsToPersian(errors);

      persianErrors.forEach(message => toast.error(message));
    },
  });
};

export default usePatchBankAccountInfo;
